import React from 'react'
import { Link } from 'react-router-dom'

import { SearchX } from 'lucide-react'

import { useIsMobile } from '@/shared/hooks/useIsMobile'

const NotFound: React.FC = () => {
  const isMobile = useIsMobile()

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '60vh',
        textAlign: 'center',
        padding: 'var(--space-2xl)',
      }}
    >
      <SearchX
        size={isMobile ? 48 : 64}
        style={{ color: 'var(--app-text-tertiary)', marginBottom: 'var(--space-2xl)' }}
      />
      <h1
        style={{
          fontSize: isMobile ? 'var(--font-size-h2)' : 'var(--font-size-h1)',
          fontWeight: 700,
          letterSpacing: 'var(--tracking-h1)',
          marginBottom: 'var(--space-xl)',
          color: 'var(--app-text-primary)',
        }}
      >
        Data Not Found
      </h1>
      <p
        style={{
          color: 'var(--app-text-tertiary)',
          marginBottom: 'var(--space-3xl)',
          maxWidth: 'var(--not-found-text-max-width)',
          fontSize: isMobile ? 'var(--font-size-lg)' : undefined,
        }}
      >
        We couldn&apos;t find any information for the requested address, transaction, or block.
      </p>
      <Link
        to="/"
        style={{
          backgroundColor: 'var(--brand-primary)',
          color: 'var(--brand-on-primary)',
          padding: 'var(--space-lg) var(--space-3xl)',
          borderRadius: 'var(--radius-md)',
          textDecoration: 'none',
          fontWeight: 'bold',
          transition: 'opacity 0.2s',
        }}
      >
        Back to Home
      </Link>
    </div>
  )
}

export default NotFound
